import omit from 'lodash/omit'

import Datepicker, { PropsType as DatepickerProps } from './DatePicker'
import Dropdown, { PropsType as DropdownProps } from './Dropdown'
import Input, { PropsType as InputProps } from './Input'
import MultiValueInput, {
  PropsType as MultiValueInputProps,
} from './MultiValueInput'
import NumberInput, { PropsType as NumberInputProps } from './NumberInput'
import TextArea, { PropsType as TextAreaProps } from './TextArea'

export interface BaseProps {
  name: string
  label?: string
  caption?: string
}

export enum InputType {
  Dropdown = 'dropdown',
  Datepicker = 'datepicker',
  Input = 'input',
  NumberInput = 'number',
  TextArea = 'textarea',
  MultiValueInput = 'multiValueInput',
}

type InputDiscriminator = {
  inputType: InputType.Input
} & InputProps

type DropdownDiscriminator<ValueType, LabelType> = {
  inputType: InputType.Dropdown
} & DropdownProps<ValueType, LabelType>

type DatepickerDiscriminator = {
  inputType: InputType.Datepicker
} & DatepickerProps

type NumberInputDiscriminator = {
  inputType: InputType.NumberInput
} & NumberInputProps

type TextAreaDiscriminator = {
  inputType: InputType.TextArea
} & TextAreaProps

type MultiValueInputDiscriminator = {
  inputType: InputType.MultiValueInput
} & MultiValueInputProps

type FieldProps<ValueType, LabelType> =
  | InputDiscriminator
  | DropdownDiscriminator<ValueType, LabelType>
  | DatepickerDiscriminator
  | NumberInputDiscriminator
  | TextAreaDiscriminator
  | MultiValueInputDiscriminator

const Field = <ValueType, LabelType>(
  props: FieldProps<ValueType, LabelType>,
) =>
  props.inputType === InputType.Input ? (
    <Input {...omit(props, ['inputType'])} />
  ) : props.inputType === InputType.Dropdown ? (
    <Dropdown {...omit(props, ['inputType'])} />
  ) : props.inputType === InputType.NumberInput ? (
    <NumberInput {...omit(props, ['inputType'])} />
  ) : props.inputType === InputType.TextArea ? (
    <TextArea {...omit(props, ['inputType'])} />
  ) : props.inputType === InputType.MultiValueInput ? (
    <MultiValueInput {...omit(props, ['inputType'])} />
  ) : (
    <Datepicker {...omit(props, ['inputType'])} />
  )

export default Field
